/// <reference path="../../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
declare var vCardParser: any;
namespace Nobox {

    @Serenity.Decorators.registerClass()
    export class InteractiveOrderDialog extends NoboxEntityDialog<any, any> {
        protected getFormKey() { return ContactMultipleForm.formKey; }

        protected form = new ContactMultipleForm(this.idPrefix);
        public saveCallback: (response: string) => void;

        constructor() {
            super();
            
        }

        getToolbarButtons() {
            return [];
        }

        AutoNumericFormatter(val) {
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }
            if (val == "" || val == null) {
                return "";
            } else {
                input.autoNumeric('set', val);
                return input.val();
            }
        }

        showFromInbox(data: string) {
            var objData = JSON.parse(data);
            var elmPdt = `<div class="card-inner card-inner-smm p-1 border-bottom"><div class="pricing-body pl-1 pr-2 py-0"><ul class="pricing-features" style="max-height: 300px; overflow: auto;">`;
            var subtotal = 0;
            var status = `<span class="lkbadge lkbadge-secondary lkbadge-dim">PENDING</span>`;
            if (objData.status_order == "processing") {
                status = `<span class="lkbadge lkbadge-warning lkbadge-dim">PROCESSING</span>`;
            } else if (objData.status_order == "shipped") {
                status = `<span class="lkbadge lkbadge-primary lkbadge-dim">SHIPPED</span>`;
            } else if (objData.status_order == "canceled") {
                status = `<span class="lkbadge lkbadge-danger lkbadge-dim">CANCELED</span>`;
            }  else if (objData.status_order == "completed") {
                status = `<span class="lkbadge lkbadge-success lkbadge-dim">COMPLETED</span>`;
            } 
            JSON.parse(objData.items).forEach((x, i) => {
                let harga = x.harga * x.Jumlah;
                subtotal += harga;
                elmPdt += `<li>
                                <div class="col pl-1 pr-3" style="margin:auto;">
                                    <div class="text text-bold">${x.Nama}</div>
                                    <div class="text" style="display: -webkit-box; -webkit-line-clamp: 1;-webkit-box-orient: vertical;overflow: hidden;text-overflow: ellipsis;">Amount ${x.Jumlah}</div>
                                </div>
                                <div class="ms-auto">${objData.mata_uang} ${this.AutoNumericFormatter(harga)}</div>
                            </li>`;
            })
            elmPdt += `</div></ul></div>`;
            this.form.ListEl.element.addClass("p-0");
            this.form.ListEl.element.find(".el-list").html(`<div class="card">
                            <div class="card-inner-group">
                                <div class="card-inner p-1 text-center border-bottom">
                                    <div class="user-card user-card-s2 text-center">
                                        <i class="fa fa-file-alt" style="font-size: 40px;"></i>
                                        <div class="mt-1">
                                            <span class="sub-text" style="line-height: 1.2">Order #${objData.id_pesanan}</span>${status}
                                        </div>
                                    </div>
                                </div>
                                ${elmPdt}
                                <div class="card-inner card-inner-smm p-1 border-bottom">
                                    <div class="pricing-body px-2 pb-1 pt-0">
                                        <ul class="pricing-features">
                                            <li style="max-height: 22px;"><span class="w-50">Subtotal</span> <span class="ms-auto">${objData.mata_uang} ${this.AutoNumericFormatter(subtotal)}</span></li>
                                            <li style="max-height: 22px;"><span class="w-50">Discount</span> <span class="ms-auto">-${objData.mata_uang} ${objData.diskon == undefined ? 0 : this.AutoNumericFormatter(objData.diskon)}</span></li >
                                            <li style="max-height: 22px;"><span class="w-50">Shipping Cost</span> <span class="ms-auto">${objData.mata_uang} ${objData.ongkir == undefined ? 0 : this.AutoNumericFormatter(objData.ongkir)}</span></li>
                                            <li style="max-height: 22px;"><span class="w-50">Tax</span> <span class="ms-auto">${objData.mata_uang} ${objData.pajak == undefined ? 0 : this.AutoNumericFormatter(objData.pajak)}</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="card-inner card-inner-smm p-1">
                                    <div class="pricing-body px-2 pb-1 pt-0">
                                        <ul class="pricing-features">
                                            <li style="max-height: 22px;"><span class="w-50">Total</span><span class="ms-auto">${objData.mata_uang} ${this.AutoNumericFormatter(objData.total_harga)}</span></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>`);
        }

        updateTitle() {
            this.dialogTitle = "Order Detail";
        }
    }
}